





import {
  formatScoreCountInline,
  usClassroomCopy,
} from "../../../data/copy/usClassroomTerms";
import { temaExportAuthor } from "../../../data/tools/toolDisplayNames";
import { sanitizeFilename } from "../sanitizeFilename";

function questionToBullets(question) {
  const bullets = [
    `Q${question.id} (${formatScoreCountInline(question.marks)}): ${question.text}`,
  ];
  if (question.options) {
    bullets.push(...question.options);
  }
  if (question.correctAnswer) {
    bullets.push(`Answer: ${question.correctAnswer}`);
  }
  return bullets;
}

function sectionToSlides(section) {
  return section.questions.map((question) => ({
    kind: "bullets",
    title: `${section.title} — Q${question.id}`,
    bullets: questionToBullets(question)
  }));
}

export function questionPaperToPptDocument(
result)
{
  const meta = result.examMetadata;

  const slides = [
  {
    kind: "title",
    title: meta.title,
    subtitle: meta.subjectLine
  },
  {
    kind: "bullets",
    title: "Exam details",
    bullets: [
    `Duration: ${meta.duration}`,
    `${usClassroomCopy("Maximum points", "Maximum marks")}: ${meta.maximumMarks}`,
    `Strategy: ${meta.questionStrategy}`]

  },
  {
    kind: "bullets",
    title: "General instructions",
    bullets: result.generalInstructions
  },
  ...result.sections.flatMap(sectionToSlides),
  {
    kind: "bullets",
    title: "Syllabus coverage",
    bullets: result.syllabusCoverage.map(
      (item) => `${item.topic}: ${formatScoreCountInline(item.marks)}`
    )
  }];


  return {
    filename: sanitizeFilename(result.topicLabel, "question-paper"),
    title: meta.title,
    subject: meta.subjectLine,
    author: temaExportAuthor("question-paper"),
    slides
  };
}